export const APIurl = process.env.REACT_APP_PRODUCTION_API as string
